<template>
  <radar-chart style="position: relative;" :height="height" :data="this.radarChartData"
              :options="this.radarChartOptions" v-if="this.radarChartData"></radar-chart>
</template>

<script>
  import RadarChart from "../Wrappers/radarChart";

  export default {
    name: "sectionsCompletionRadar",
    components: {RadarChart},
    props: ['profile', 'height'],
    data() {
      return {
        radarChartData: {},
        radarChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: 'top'
          },
          scale: {
            ticks: {
              suggestedMax: 100
            }
          },
          tooltips: {
            callbacks: {
              title: function(tooltipItem, data) {
                return data.labels[tooltipItem[0].index];
              }
            }
          }
        }
      }
    },
    methods: {
      composeRadarChartData() {
        let profileCompletion = JSON.parse(JSON.stringify(this.profile.edges.market.profileCompletion));
        delete profileCompletion.total;
        delete profileCompletion.scrapedDate;
        const labels = Object.keys(profileCompletion);
        const datasets = [
          {
            label: 'Current profile completion',
            labels: labels,
            // lineTension: 0,
            backgroundColor: 'rgb(0, 150, 170, 0.6)',
            borderColor: '#007866',
            // fill: false,
            data: Object.values(profileCompletion)
          }
        ];

        return {labels, datasets};
      }
    },
    mounted() {
      this.radarChartData = this.composeRadarChartData();
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Profile/sectionsCompletionRadar.vue